export const APPCUES_ID = {
    CUSTOM_INPUT_EMAIL: 'CUSTOM_INPUT_EMAIL',
    SWITCH_BUTTON_WITH_LABEL: 'SWITCH_BUTTON_WITH_LABEL',
};

export const TEAM_TEST_IDS = {
    OPEN_MODAL_BUTTON: 'OPEN_MODAL_BUTTON',
    SEARCH_MEMBER_INPUT: 'SEARCH_MEMBER_INPUT',
    SEARCH_INVITEE_INPUT: 'SEARCH_INVITEE_INPUT',
};

export const TEAM_TEXTS = {
    TITLE: 'Team Members',
    INVITE_BUTTON: 'Send',

};

export const TEAM_REMOVE_INVITE = {
    TITLE: 'Remove selected invite?',
    DELETE_TEXT: 'Are you sure you want to remove this invite?',
};

export const TEAM_REMOVE_MEMBER = {
    TITLE: 'Remove selected user?',
    DELETE_TEXT: 'Are you sure you want to remove this user?',
};

export const REMOVE_BUTTONS = {
    CANCEL_BUTTON: 'Cancel',
    CONFIRM_BUTTON: 'Remove',
};

export const TEAM_TYPE = {
    ADMIN: {
        value: 'admin',
        label: 'Admin',
    },
    MEMBER: {
        value: 'member',
        label: 'Member',
    },
    INVITE: {
        value: 'invite',
        label: 'Invite',
    },
};

export const TOAST_TEAM = {
    EDIT_MEMBER_ROLE_SUCCEEDED: 'The Access type of user $MemberName has been updated.',
};

export const SEARCH_INPUT_PLACEHOLDER = 'Search...';

export const TABLE_TITLE = {
    MEMBERS_LIST: 'Members List',
    PENDING_INVITATIONS: 'Pending Invitations',
};
